export default __webpack_public_path__ + "src/images/galleries/0/sidebar_text-a77456.png";